// Set last order action type
export const SET_LAST_ORDER = "SET_LAST_ORDER";

// Set last order action creator
export const setLastOrderDetails = (data) => ({
  type: SET_LAST_ORDER,
  payload: data,
});
